import React from "react";

const TailwindPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  MAX_VISIBLE = 5,
}) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= MAX_VISIBLE + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= MAX_VISIBLE) {
        for (let i = 1; i <= MAX_VISIBLE; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - MAX_VISIBLE + 1) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - MAX_VISIBLE + 1; i <= totalPages; i++)
          pages.push(i);
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center mt-4 space-x-1">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
      >
        &lt;
      </button>

      {getPageNumbers().map((page, idx) =>
        page === "..." ? (
          <span key={idx} className="px-3 py-1 border rounded select-none">
            ...
          </span>
        ) : (
          <button
            key={idx}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 border rounded hover:bg-gray-100 ${
              currentPage === page ? "bg-gray-300 font-bold" : ""
            }`}
          >
            {page}
          </button>
        ),
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
      >
        &gt;
      </button>
    </div>
  );
};

export default TailwindPagination;
